import { removeCookie } from './cookies';
import { $ } from './utils';

function clearCookiePreferences() {
    removeCookie('jet-consent-courierweb');
}

export const initCookieStatement = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const managePreferencesLink = $('#managePreferencesLink');

        if (managePreferencesLink) {
            managePreferencesLink.onclick = function () {
                clearCookiePreferences();
            };
        }
    });
};
